import axios from './axiosConfig'

export const allTrending = async () => {
  const response = await axios.get('/tranding')
  console.log(response.data)
  return response.data
}

export const getTrendingById = async (id) => {
  const response = await axios.get(`/tranding/${id}`)
  console.log('response at api', response.data)
  return response.data
}

export const createTrending = async (formData) => {
  const data = new FormData()

  data.append('title', formData.title)
  data.append('description', formData.description)
  data.append('pageUrl', formData.pageUrl)
  data.append('tagUrl', formData.tagUrl)

  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  try {
    const response = await axios.post('/tranding', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error creating trending:', error)
    throw error
  }
}

export const updateTrending = async (id, formData) => {
  const data = new FormData()

  data.append('title', formData.title)
  data.append('description', formData.description)
  data.append('pageUrl', formData.pageUrl)
  data.append('tagUrl', formData.tagUrl)

  // Only append image if a new one is provided
  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  console.log('update trending', data)
  try {
    const response = await axios.put(`/tranding/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error updating trending:', error)
    throw error
  }
}

export const deleteTranding = async (id, otp) => {
  try {
    const response = await axios.delete(`/tranding/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete tranding response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting tranding:', error)
    throw error
  }
}

export const sendMail = async (id) => {
  try {
    const response = await axios.get(`/tranding/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching sliders:', error)
    throw error
  }
}
